




































import { Component, Prop, Vue } from 'vue-property-decorator';
import BarChart from '@/features/reports/components/chartjs/BarChart.vue';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import ChartError from '@/features/reports/components/ChartError.vue';
import ChartLabels from '@/features/reports/components/ChartLabels.vue';
import ChartNoData from '@/features/reports/components/ChartNoData.vue';
import HelpIcon from 'vue-material-design-icons/HelpCircleOutline.vue';
import { Data, Series, SeriesConfig } from '@/features/reports/models';
import shortid from 'shortid';

@Component({
	components: {
		BarChart,
		LoadingSpinner,
		ChartError,
		ChartNoData,
		ChartLabels,
		HelpIcon,
	},
})
export default class ProactiveTriggersTrendChart extends Vue {
	@Prop() public data!: Data;

	@Prop() public loadedData!: boolean;

	@Prop() public loadingError!: boolean;

	public reportId = '';

	public tooltipText = 'A trend showing the number of proactive flows that were started and the number that were blocked from starting due to the monthly limit being reached';

	public created() {
		this.reportId = `${shortid.generate()}`;
	}

	public get seriesOrder(): SeriesConfig[] {
		return [
			{ name: 'Started', displayName: 'Proactive Triggers Started', colour: '#062B80' },
			{ name: 'Blocked', displayName: 'Proactive Triggers Blocked', colour: '#FF6666' }
		];
	}

	public get reportData(): Data {
		return {
			scale: this.data.scale,
			series: this.seriesOrder.map(seriesConfig => {
				return this.data.series.find(s => s.name === seriesConfig.name)
					|| this.createBlankSeries(seriesConfig.name, seriesConfig.displayName);
			})
		};
	}

	public createBlankSeries(name: string, displayName: string): Series {
		return {
			name,
			displayName: displayName || name,
			data: this.data.scale.labels.map(() => 0)
		};
	}

	public get loadedAndNotReturnedData() {
		return this.loadedData && (!this.data || !this.data.series || this.data.series.length === 0);
	}

	public get loadedAndReturnedData() {
		return this.loadedData && this.data && this.data.series && this.data.series.length > 0;
	}
}
